import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Pose tutorials made for students, not for teaching a room', 'One pose at a time — you still build the other 55 minutes', 'Nothing for the first-timer and the advanced pair at once', 'Spotting and exits left for you to explain from memory', 'Every week starts from zero again'];
const withIt = ['60 complete sessions, start to finish', 'Every skill in 3 lanes: Ground, Lift, Fly', 'Spotter position and the way down in every lane', 'Timed blocks for 45, 60 or 90 minutes', 'Odd numbers, easier and harder already written in'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="arcs-light w-full bg-sand" data-id="element-389" data-mp="295e9n9m2qztm">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-390" data-mp="2d6zjsn785004">
        <div className="text-center" data-id="element-391" data-mp="30y50f4kznwbh">
          <p className="eyebrow text-coral-deep" data-id="element-392" data-mp="30x3icg5k29k9">
            Why this isn&apos;t another pose library
          </p>
          <h2 id="vs-heading" className="lane-underline mt-3 font-display text-[30px] leading-tight text-night sm:text-5xl" data-id="element-393" data-mp="35qy4dq8mv0mi">
            Pose videos vs{' '}
            <span className="text-lift-deep" data-id="element-394" data-mp="1oeffsoyw2pw9">a planned class</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-night-soft" data-id="element-395" data-mp="236ha7ti6wqow">
            Yes, there are free flow videos online, and teacher manuals that
            only come with trainings costing $1,200 or more. Finding poses was
            never the hard part — turning them into a class that works for
            everyone on the mats is. That&apos;s the part this does for you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-3xl border border-sand-dark shadow-card" data-id="element-396" data-mp="2m1xxwqefx4cx">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-397" data-mp="2h34hap3uwx8j">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-398" data-mp="rqj5g1u1oqth">
              Poses
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/85 sm:text-[11px]" data-id="element-399" data-mp="mt0z8j7ewpp6">
              Free videos &amp; lists
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-400" data-mp="2rt1ysu7is295">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-401" data-mp="2vssw7grjxgmn">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-402" data-mp="35s9yrpbibeee">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-403" data-mp="3aqbimcgrbhqx" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-night px-3.5 py-4 text-white sm:p-6" data-id="element-404" data-mp="3jjola64mhxq7">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-405" data-mp="3oijfe481j8pm">
              Classes
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-coral sm:text-[11px]" data-id="element-406" data-mp="3th31c4mmwkhz">
              Acro Yoga Class Ready
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-407" data-mp="7e2eufndo59b">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-semibold leading-snug sm:text-sm" data-id="element-408" data-mp="2fr4m3t67sqk">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-ground" data-id="element-409" data-mp="3pmtff52cndr3">
                    <CheckIcon className="h-2.5 w-2.5 text-night" aria-hidden="true" data-id="element-410" data-mp="q64vhr00rljk" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}